<template>
  <div class="page">
    <Header title="切换修理厂"></Header>
    <div class="clint-info-box">
      <div v-for="(item,index) of clientList" :key="index" class="client-info">
        <div class="client-info-center">
          <div class="client-info-name">{{item.clientName}}</div>
          <div class="client-info-point">
            <div class="client-info-point-item" v-for="(point,index) of item.pointList" :key="index">{{point.pointTypeName}}:{{point.pointValue}}</div>
          </div>
          <div class="client-info-address">{{item.provinceName+item.cityName+item.countyName}}</div>
        </div>
        <div v-show="item.clientId!==clientId" @click="changeWorkshop(item.clientId)" class="change-btn">切换</div>
      </div>
    </div>
    <ReturnToLogin ref="ReturnToLogin" @after-confirm="handleJumpHome"></ReturnToLogin>
  </div>
</template>

<script>
import Header from '../../components/header.vue'
import ReturnToLogin from '@/views/activity/components/return-to-login.vue'
import centerApi from '@/api/center.js'
import { userUtils } from '@/utils/auth'
export default {
  components: { Header, ReturnToLogin },
  data () {
    return {
      clientList: [],
      clientId: ''
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      centerApi.clientUserWorkshopList().then(res => {
        if (res.data.resultCode === '0') {
          this.clientList = res.data.resultData.clientList
        }
      })
      centerApi.getClientInfo().then(res => {
        if (res.data.resultCode === '0') {
          this.clientId = res.data.resultData.clientInfo.clientId
        }
      })
    },
    changeWorkshop (clientId) {
      let data = {
        clientId
      }
      centerApi.clientUserWorkshopChange(data).then(res => {
        if (res.data.resultCode === '0') {
          userUtils.setUserLocal(res.data.resultData)
          if (res.data.resultData.activityCoinDTO) {
            // 回归活动
            this.$refs['ReturnToLogin'] && this.$refs['ReturnToLogin'].open(res)
          } else {
            this.handleJumpHome(res)
          }
        }
      })
      // centerApi.clientUserWorkshopChange(data).then(res => {
      //   if (res.data.resultCode === '0') {
      //     wxAppApi
      //       .authLogin(this.user)
      //       .then(res => {
      //         this.$toast.clear()
      //         if (res.data.resultCode === '0') {
      //           userUtils.setUserLocal(res.data.resultData)
      //           this.$router.push({ name: 'home-main' })
      //           // if (this.fromSource) {
      //           //   this.$router.push({ name: this.redirectUrl, query: { type: this.type, fromSource: this.$route.query.fromSource } })
      //           // } else {
      //           //   this.$router.replace({ name: this.redirectUrl })
      //           // }
      //         }
      //       })
      //       .catch(() => {
      //         this.$toast.clear()
      //       })
      //   }
      // })
    },
    handleJumpHome (res) {
      if (res.data.resultData.clientInfo.isActivated === 0) {
        this.$dialog.alert({
          title: '提示',
          message: '该账号未激活，即将前往激活页面'
        }).then(() => {
          this.$router.push({ name: 'activation_step_one' })
        })
      } else {
        this.$router.push({ name: 'home-main' })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.clint-info-box{
  margin-top:15px;
  width: 94%;
  margin-left: 3%;
}
.client-info{
  background-color: #fff;
  margin-bottom: 15px;
  padding: 0 5px;
  border-radius: 5px;
  position: relative;
  .client-info-center{
    padding-bottom: 10px;
  }
  .client-info-name{
    font-size: 16px;
    font-weight: 600;
    line-height: 30px;
  }
  .client-info-point{
    line-height: 22px;
    color: grey;
    font-size: 12px;
    display: flex;
  }
.client-info-address{
    line-height: 20px;
    color: grey;
    font-size: 12px;
  }
  .client-info-point-item{
    padding-right: 20px;
    flex: 1;
  }
  .change-btn{
    background-color: var(--base-green);
    text-align: center;
    color: white;
    border-radius: 12px;
    position: absolute;
    font-size: 12px;
    padding: 5px 17px;
    right: 10px;
    bottom: 6px;
  }
}
.client-info-point{
  display: flex;
}
</style>
